import React, { useState } from "react";

import { PortalApi, PortalApiAlumno, PortalApiPersonal, PublicacionPortal } from "../../../../services/v2/classPortal.service";
import { BloqueEncuesta, DatosEncuesta, ResultadosEncuesta } from "../../../../services/v2/lmsQuiz.service";
import { aCampoFecha, Avatar, Icono, mensajeDeError } from "../comun";
import "../tareas/tareas.css";
import "./quiz.css";

/*
	Encuestas en el Muro (Portal de Clase, Parte D): sin nota. El maestro publica una pregunta con 2 a 10 opciones, una o varias
	respuestas, anónima o no, cierre opcional y cuándo ven los resultados los alumnos (Después De Votar / Al Cerrar / Nunca).
	El alumno vota y puede cambiar su voto mientras siga abierta. El maestro siempre ve los conteos y, si no es anónima, quién
	votó qué (en una anónima el servidor no manda nombres). Los porcentajes son sobre las personas que votaron.
*/

const RESULTADOS: [ResultadosEncuesta, string][] = [["votar", "Después De Votar"], ["cerrar", "Al Cerrar"], ["nunca", "Nunca"]]
const pct = (n: number | undefined): string => String(Math.round(n || 0)) + " %"

// ---------------------------------------------------------------- en la tarjeta del muro

interface PropsBloque { api: PortalApi; post: PublicacionPortal; poll: BloqueEncuesta; esAlumno: boolean; onCambio: (p: PublicacionPortal) => void }

export const BloqueEncuestaVista: React.FC<PropsBloque> = ({ api, post, poll, esAlumno, onCambio }) => {
	const [elegidas, setElegidas] = useState<number[]>(poll.myVotes || [])
	const [cambiando, setCambiando] = useState<boolean>(false)
	const [quien, setQuien] = useState<boolean>(false)
	const [ocupado, setOcupado] = useState<boolean>(false)
	const [error, setError] = useState<string | null>(null)

	const datos = (
		<div className="pcTareaDatos">
			{poll.closed ? <span className="pcChip pcChipBorde">Cerrada</span> : poll.closesLabel ? <span className="pcChip pcChipBorde">Cierra {poll.closesLabel}</span> : null}
			{poll.multiple ? <span className="pcChip pcChipBorde">Varias Respuestas</span> : null}
			{poll.anonymous ? <span className="pcChip pcChipBorde">Anónima</span> : null}
			{!esAlumno ? <span className="pcChip pcChipBorde">Resultados: {RESULTADOS.find((r) => r[0] === poll.results)?.[1] || ""}</span> : null}
		</div>
	)

	// ---- personal: conteos siempre; nombres solo si no es anónima
	if (!esAlumno) {
		const conNombres = !poll.anonymous && poll.options.some((o) => (o.voters || []).length > 0)
		return (
			<div className="enOpciones">
				{datos}
				{poll.options.map((o) => (
					<React.Fragment key={o.id}>
						<div className="enOpcion" aria-label={o.text + ": " + (o.votes || 0) + " votos, " + pct(o.pct)}>
							<span className="enLleno" style={{ width: Math.min(100, o.pct || 0) + "%" }} aria-hidden="true" />
							<span className="enTexto">{o.text}</span>
							<span className="pcTenue pcChico" style={{ fontWeight: 700 }}>{o.votes || 0}</span>
							<span className="enPct">{pct(o.pct)}</span>
						</div>
						{quien && (o.voters || []).length > 0 ? (
							<div className="enVotantes">{(o.voters || []).map((v) => <span className="enVotante" key={v.id}><Avatar a={{ name: v.name, initials: v.initials, photo: v.photo }} size={22} /><span>{v.name}</span></span>)}</div>
						) : null}
					</React.Fragment>
				))}
				<div className="pcTenue pcChico" style={{ display: "flex", gap: 10, flexWrap: "wrap", alignItems: "center" }}>
					<span>{poll.voters ?? 0} De {poll.students ?? 0} Votaron</span>
					{conNombres ? <button type="button" className="pcEnlaceBtn" style={{ minHeight: 32, fontSize: 13.5 }} aria-expanded={quien} onClick={() => setQuien(!quien)}>{quien ? "Ocultar Quién Votó" : "Ver Quién Votó"}</button> : null}
					{poll.anonymous ? <span>Anónima: no se sabe quién votó qué.</span> : null}
				</div>
			</div>
		)
	}

	// ---- alumno
	const votar = async (ids: number[]) => {
		const v = (api as PortalApiAlumno).vote
		if (!v || ocupado) return
		setOcupado(true); setError(null)
		try { const p = await v(post.id, ids); onCambio(p); setElegidas(p.poll?.myVotes || ids); setCambiando(false) } catch (e) { setError(mensajeDeError(e)) } finally { setOcupado(false) }
	}
	const alternar = (id: number) => setElegidas(poll.multiple ? (elegidas.includes(id) ? elegidas.filter((x) => x !== id) : [...elegidas, id]) : [id])
	const eligiendo = !!poll.canVote && (!poll.voted || cambiando)

	if (eligiendo) {
		return (
			<div className="enOpciones" role={poll.multiple ? "group" : "radiogroup"} aria-label={post.title || "Encuesta"}>
				{datos}
				{poll.options.map((o) => {
					const on = elegidas.includes(o.id)
					return (
						<button key={o.id} type="button" role={poll.multiple ? "checkbox" : "radio"} aria-checked={on} className="enOpcion" onClick={() => alternar(o.id)}>
							<span className={"qzBolita" + (poll.multiple ? " qzBolitaCuadro" : "")} style={on ? { background: "var(--pc-acento)", borderColor: "var(--pc-acento)" } : undefined} aria-hidden="true">{on ? <Icono n="check" size={14} /> : null}</span>
							<span className="enTexto">{o.text}</span>
						</button>
					)
				})}
				<div className="pcRedactorBotones">
					<button type="button" className="pcBtn pcBtnP" disabled={ocupado || elegidas.length === 0} onClick={() => votar(elegidas)}>{poll.voted ? "Guardar Mi Voto" : "Votar"}</button>
					{cambiando ? <button type="button" className="pcBtn pcBtnS" disabled={ocupado} onClick={() => { setCambiando(false); setElegidas(poll.myVotes || []) }}>Cancelar</button> : null}
					{cambiando && poll.voted ? <button type="button" className="pcEnlaceBtn" disabled={ocupado} onClick={() => votar([])}>Quitar Mi Voto</button> : null}
				</div>
				{poll.multiple ? <div className="pcTenue pcChico">Puedes elegir varias.</div> : null}
				{error ? <div className="pcAviso pcOro" role="alert">{error}</div> : null}
			</div>
		)
	}

	const mias = poll.myVotes || []
	return (
		<div className="enOpciones">
			{datos}
			{poll.resultsVisible ? poll.options.map((o) => (
				<div key={o.id} className="enOpcion" aria-label={o.text + ": " + pct(o.pct) + (mias.includes(o.id) ? ", tu voto" : "")}>
					<span className="enLleno" style={{ width: Math.min(100, o.pct || 0) + "%" }} aria-hidden="true" />
					<span className="enTexto">{o.text}</span>
					{mias.includes(o.id) ? <span className="enMio">Tu Voto</span> : null}
					<span className="enPct">{pct(o.pct)}</span>
				</div>
			)) : (
				<div className="pcNota">
					{poll.voted ? "Votaste: " + poll.options.filter((o) => mias.includes(o.id)).map((o) => o.text).join(", ") + ". " : poll.closed ? "La encuesta ya cerró. " : ""}
					{poll.results === "cerrar" && !poll.closed ? "Los resultados se ven cuando cierre." : poll.results === "nunca" ? "Tu maestro no muestra los resultados." : ""}
				</div>
			)}
			<div className="pcTenue pcChico" style={{ display: "flex", gap: 10, flexWrap: "wrap", alignItems: "center" }}>
				{poll.voters !== null ? <span>{poll.voters === 1 ? "1 Voto" : poll.voters + " Votos"}</span> : null}
				{poll.closed ? <span>Cerrada</span> : null}
				{poll.canVote && poll.voted ? <button type="button" className="pcEnlaceBtn" style={{ minHeight: 32, fontSize: 13.5 }} onClick={() => { setElegidas(mias); setCambiando(true) }}>Cambiar Mi Voto</button> : null}
			</div>
			{error ? <div className="pcAviso pcOro" role="alert">{error}</div> : null}
		</div>
	)
}

// ---------------------------------------------------------------- redactor del maestro

interface PropsRedactor { api: PortalApiPersonal; inicial?: PublicacionPortal | null; onGuardado: (p: PublicacionPortal) => void; onCancelar: () => void }

export const RedactorEncuesta: React.FC<PropsRedactor> = ({ api, inicial, onGuardado, onCancelar }) => {
	const poll = inicial?.poll || null
	const conVotos = !!poll?.hasVotes
	const [pregunta, setPregunta] = useState<string>(inicial?.title || "")
	const [opciones, setOpciones] = useState<{ id?: number; text: string }[]>(poll ? poll.options.map((o) => ({ id: o.id, text: o.text })) : [{ text: "" }, { text: "" }])
	const [varias, setVarias] = useState<boolean>(!!poll?.multiple)
	const [anonima, setAnonima] = useState<boolean>(!!poll?.anonymous)
	const [cierra, setCierra] = useState<string>(poll?.closesMs ? (poll.closesInput || aCampoFecha(poll.closesMs)) : "")
	const [resultados, setResultados] = useState<ResultadosEncuesta>(poll?.results || "votar")
	const [fijar, setFijar] = useState<boolean>(!!inicial?.pinned)
	const [programar, setProgramar] = useState<string>(inicial?.status === "programada" ? (inicial.whenInput || aCampoFecha(inicial.whenMs)) : "")
	const [guardando, setGuardando] = useState<boolean>(false)
	const [error, setError] = useState<string | null>(null)

	const publicar = async (borrador: boolean) => {
		if (guardando) return
		setError(null)
		if (pregunta.trim() === "") { setError("Escribe la pregunta de la encuesta."); return }
		const limpias = opciones.map((o) => ({ ...o, text: o.text.trim() })).filter((o) => o.text !== "")
		if (limpias.length < 2) { setError("Pon al menos 2 opciones."); return }
		if (new Set(limpias.map((o) => o.text.toLowerCase())).size !== limpias.length) { setError("Hay opciones repetidas."); return }
		const p: DatosEncuesta = { closesAt: cierra || null, results: resultados }
		if (!conVotos) { p.options = limpias.map((o) => (o.id ? { id: o.id, text: o.text } : o.text)); p.multiple = varias; p.anonymous = anonima }
		setGuardando(true)
		try {
			const d = { type: "encuesta" as const, title: pregunta.trim(), pinned: fijar, publishAt: programar || null, draft: borrador, poll: p }
			onGuardado(inicial ? await api.updatePost(inicial.id, d) : await api.createPost({ ...d, unitId: null }))
		} catch (e) { setError(mensajeDeError(e)) } finally { setGuardando(false) }
	}

	return (
		<div className="pcTarjeta pcRedactor">
			<div className="pcFilaAutor">
				<span className="pcTituloPost" style={{ flex: 1 }}>{inicial ? "Editar Encuesta" : "Nueva Encuesta"}</span>
				<button type="button" className="pcIb" aria-label="Cerrar" onClick={onCancelar}><Icono n="cerrar" /></button>
			</div>
			<div className="pcCampo">
				<label className="pcCampoEtiqueta" htmlFor="enPregunta">Pregunta</label>
				<input id="enPregunta" className="pcInput" maxLength={200} placeholder="¿Qué Día Hacemos El Repaso?" value={pregunta} onChange={(e) => setPregunta(e.target.value)} />
			</div>
			<div className="pcCampo">
				<span className="pcCampoEtiqueta">Opciones</span>
				{opciones.map((o, i) => (
					<div className="enOpcionForma" key={o.id ?? "n" + i}>
						<label htmlFor={"enOp" + i} style={{ position: "absolute", left: -9999 }}>Opción {i + 1}</label>
						<input id={"enOp" + i} className="pcInput" maxLength={200} placeholder={"Opción " + (i + 1)} value={o.text} disabled={conVotos} onChange={(e) => setOpciones(opciones.map((x, j) => (j === i ? { ...x, text: e.target.value } : x)))} />
						{!conVotos && opciones.length > 2 ? <button type="button" className="pcIb" style={{ width: 40, height: 40 }} aria-label={"Quitar la opción " + (i + 1)} onClick={() => setOpciones(opciones.filter((_, j) => j !== i))}><Icono n="cerrar" size={16} /></button> : null}
					</div>
				))}
				{!conVotos && opciones.length < 10 ? <button type="button" className="pcEnlaceBtn" style={{ alignSelf: "flex-start" }} onClick={() => setOpciones([...opciones, { text: "" }])}>Agregar Opción</button> : null}
				{conVotos ? <div className="pcTenue pcChico">Ya hay votos: las opciones, "varias respuestas" y "anónima" ya no se cambian.</div> : null}
			</div>
			<div className="tkSegmentos" role="radiogroup" aria-label="Cuántas respuestas">
				<button type="button" role="radio" aria-checked={!varias} className="tkSegmento" aria-pressed={!varias} disabled={conVotos} onClick={() => setVarias(false)}>Una Respuesta<small>Eligen una</small></button>
				<button type="button" role="radio" aria-checked={varias} className="tkSegmento" aria-pressed={varias} disabled={conVotos} onClick={() => setVarias(true)}>Varias Respuestas<small>Eligen las que quieran</small></button>
			</div>
			<div className="pcInterruptorFila" style={{ borderTop: 0, minHeight: 48 }}>
				<span>Anónima<small className="pcTenue" style={{ display: "block", fontWeight: 500, fontSize: 12.5 }}>Ni tú verás quién votó qué</small></span>
				<button type="button" role="switch" aria-checked={anonima} aria-label="Encuesta anónima" disabled={conVotos} className={"pcSw" + (anonima ? " pcSwOn" : "")} onClick={() => setAnonima(!anonima)} />
			</div>
			<div className="pcCampo">
				<span className="pcCampoEtiqueta">Los Alumnos Ven Los Resultados</span>
				<div className="tkSegmentos" role="radiogroup" aria-label="Cuándo ven los resultados">
					{RESULTADOS.map(([id, texto]) => <button key={id} type="button" role="radio" aria-checked={resultados === id} className="tkSegmento" aria-pressed={resultados === id} onClick={() => setResultados(id)}>{texto}</button>)}
				</div>
			</div>
			<div className="pcRedactorBotones">
				<div className="pcCampo" style={{ flex: "1 1 220px" }}>
					<label className="pcCampoEtiqueta" htmlFor="enCierra">Cierra (Opcional, Hora De México)</label>
					<input id="enCierra" type="datetime-local" className="pcInput" value={cierra} onChange={(e) => setCierra(e.target.value)} />
				</div>
				{!inicial || inicial.status !== "publicada" ? (
					<div className="pcCampo" style={{ flex: "1 1 220px" }}>
						<label className="pcCampoEtiqueta" htmlFor="enProgramar">Programar (Hora De México)</label>
						<input id="enProgramar" type="datetime-local" className="pcInput" value={programar} onChange={(e) => setProgramar(e.target.value)} />
					</div>
				) : null}
			</div>
			<div className="pcRedactorPie">
				<label style={{ display: "inline-flex", gap: 8, alignItems: "center", fontWeight: 600, fontSize: 14.5, minHeight: 44 }}>
					<input type="checkbox" checked={fijar} onChange={(e) => setFijar(e.target.checked)} style={{ width: 20, height: 20, accentColor: "var(--pc-acento)" }} />Fijar Arriba
				</label>
				<div className="pcDerecha">
					{!inicial || inicial.status !== "publicada" ? <button type="button" className="pcBtn pcBtnS" disabled={guardando} onClick={() => publicar(true)}>Guardar Borrador</button> : null}
					<button type="button" className="pcBtn pcBtnP" disabled={guardando} onClick={() => publicar(false)}>{programar ? "Programar" : inicial ? "Guardar" : "Publicar"}</button>
				</div>
			</div>
			{error ? <div className="pcAviso pcOro" role="alert">{error}</div> : null}
		</div>
	)
}

/** Cerrar ya o reabrir (menú de la tarjeta del maestro). */
export const cerrarEncuesta = (api: PortalApiPersonal, post: PublicacionPortal, cerrar: boolean): Promise<PublicacionPortal> => api.updatePost(post.id, { poll: { close: cerrar } })
